import React from 'react';

export default function Detections(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <path d="M3.176 3.176v3.53a.588.588 0 0 1-1.176 0V2.588C2 2.263 2.263 2 2.588 2h4.118a.588.588 0 0 1 0 1.176h-3.53zm17.648 0h-3.53a.588.588 0 0 1 0-1.176h4.118c.325 0 .588.263.588.588v4.118a.588.588 0 0 1-1.176 0v-3.53zM3.176 20.824h3.53a.588.588 0 0 1 0 1.176H2.588A.588.588 0 0 1 2 21.412v-4.118a.588.588 0 0 1 1.176 0v3.53zm17.648 0v-3.53a.588.588 0 0 1 1.176 0v4.118a.588.588 0 0 1-.588.588h-4.118a.588.588 0 0 1 0-1.176h3.53zm-4.412-5.295a.588.588 0 0 1-.588.589H8.176a.588.588 0 0 1-.588-.589V9.647c0-.258.169-.486.415-.562l7.648-2.353a.588.588 0 0 1 .76.562v8.235zm-1.177-.588v-6.85l-6.47 1.99v4.86h6.47z" />
    </svg>
  );
}
